import { render, staticRenderFns } from "./AppMain.vue?vue&type=template&id=00f06db9&scoped=true"
import script from "./AppMain.vue?vue&type=script&lang=js"
export * from "./AppMain.vue?vue&type=script&lang=js"
import style0 from "./AppMain.vue?vue&type=style&index=0&id=00f06db9&prod&scoped=true&lang=css"
import style1 from "./AppMain.vue?vue&type=style&index=1&id=00f06db9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f06db9",
  null
  
)

export default component.exports